import { useState } from "react";
import { useSetPageTitle } from "src/hooks/useSetPageTitle";
import { AppLayout } from "src/components/layout/app-layout";
import ReportsTab from "./tabs/reports.tab";
import InsightsTab from "./tabs/insights.tab";


const ReportsPage = () => {
  useSetPageTitle('Client Reports');
  const [activeTab, setActiveTab] = useState<'reports' | 'insights'>('reports');

  const clientReportsTabs = [
    {
      id: 'reports',
      label: 'Reports',
      onClick: () => setActiveTab('reports'),
    },
    {
      id: 'insights',
      label: 'Insights',
      onClick: () => setActiveTab('insights'),
    },
  ];

  // New layout for org admins and regular users
  return (
    <AppLayout
      activePage="/client/reports"
      navbarProps={{
        showBackButton: true,
        backPath: "/client/dashboard",
        tabs: clientReportsTabs,
        activeTab: activeTab,
        onTabChange: (tabId: string) => setActiveTab(tabId as 'reports' | 'insights'),
      }}
    >
      <div className="h-[calc(100vh-8rem)]">
        {activeTab === 'reports' && <ReportsTab />}
        {activeTab === 'insights' && <InsightsTab />}
      </div>
    </AppLayout>
  );
};

export default ReportsPage;